// Los contadores de las pestañas Clientes y Prospectos: cargando o con error no afirman un número,
// y con más por traer dicen un mínimo («25+»). Puro.
import { CUSTOMERS_NOUN, loadedCountTitle, type LoadedScope } from '@/shared/patterns/LoadedScope';
import { PENDING_CELL } from './customersFormat';

export interface TabCount {
    count: string;
    title?: string;
}

const CUSTOMERS_TITLE = 'Clientes que te han comprado';
const PROSPECTS_TITLE = 'Prospectos de tu agenda';
const READ_FAILED_TITLE = 'No se pudo leer; el número aparece cuando la lectura funcione.';
const LOADING_TITLE = 'Cargando…';

/** El número, o un mínimo si quedan más por traer. */
function minimumLabel(count: number, hasMore: boolean): string {
    return hasMore ? `${String(count)}+` : String(count);
}

/** Clientes cargados de la cartera; con páginas pendientes es un mínimo. */
export function customersTabCount(input: {
    isPending: boolean;
    failed: boolean;
    scope: LoadedScope;
}): TabCount {
    if (input.failed) return { count: PENDING_CELL, title: READ_FAILED_TITLE };
    if (input.isPending) return { count: PENDING_CELL, title: LOADING_TITLE };
    return {
        count: minimumLabel(input.scope.loaded, input.scope.hasMore),
        title: loadedCountTitle(CUSTOMERS_TITLE, input.scope, CUSTOMERS_NOUN),
    };
}

/** Tamaño de la agenda; si llegó recortada es un mínimo. */
export function prospectsTabCount(input: {
    /** La lectura está habilitada (sin vendedor en sesión no se pide y nunca va a llegar). */
    enabled: boolean;
    failed: boolean;
    list: { items: readonly unknown[]; truncated: boolean } | undefined;
}): TabCount {
    if (!input.enabled && input.list === undefined) return { count: PENDING_CELL };
    if (input.failed && input.list === undefined) {
        return { count: PENDING_CELL, title: READ_FAILED_TITLE };
    }
    if (input.list === undefined) return { count: PENDING_CELL, title: LOADING_TITLE };
    const { items, truncated } = input.list;
    return {
        count: minimumLabel(items.length, truncated),
        title: truncated
            ? `${PROSPECTS_TITLE}. La agenda llegó recortada: hay más de los que se cuentan.`
            : PROSPECTS_TITLE,
    };
}
